import { axios } from '@yarmill/utils';
import { AxiosPromise } from 'axios';

export function checkIfEmailExists(email: string): AxiosPromise<boolean> {
  return axios.get('api/Account/EmailExists', { params: { email } });
}
